<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

extend('date_after_or_equal', {
  params: ['target'],
  validate(value, { target }) {
    if (!value || !target) return true;
    const valueDate = new Date(value);
    const targetDate = new Date(target);
    return valueDate >= targetDate;
  },
  message: 'A data final deve ser igual ou posterior à data inicial',
});

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        comunicadoid: '',
        comunicadotitulo_ptbr: '',
        comunicadotitulo_enus: '',
        comunicadotitulo_eses: '',
        comunicadoconteudo_ptbr: '',
        comunicadoconteudo_enus: '',
        comunicadoconteudo_eses: '',
        comunicadodatainicial: '',
        comunicadodatafinal: '',
        tipocomunicadoid: '',
        comunicadoativo: '',
        comunicadotipotexto: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      isFormValid: true,
      dataFromApiTipoComunicado: [],
      hasSubmitted: false,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTipoComunicado();
      this.formatarDatas();
      this.hasSubmitted = false;
      this.dataForm.comunicadoativo = this.dataForm.comunicadoativo == 1 || this.dataForm.comunicadoativo === '1' ? 1 : 0;
    },
    formatarDatas() {
      if (this.dataForm.comunicadodatainicial) {
        if (typeof this.dataForm.comunicadodatainicial === 'string'
            && this.dataForm.comunicadodatainicial.includes('T')) {
          this.dataForm.comunicadodatainicial = this.dataForm.comunicadodatainicial.split('T')[0];
        }
      }

      if (this.dataForm.comunicadodatafinal) {
        if (typeof this.dataForm.comunicadodatafinal === 'string'
            && this.dataForm.comunicadodatafinal.includes('T')) {
          this.dataForm.comunicadodatafinal = this.dataForm.comunicadodatafinal.split('T')[0];
        }
      }
    },
    async validateForm(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.hasSubmitted = true;

      const valid = await this.$refs.refFormData.validate();

      if (valid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Atenção',
            text: 'Preencha todos os campos corretamente.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
    },
    async fetchDataFromTipoComunicado() {
      try {
        const response = await axios.get('/tipo-comunicado');
        this.dataFromApiTipoComunicado = response.data.data.map((option) => ({
          value: option.tipocomunicadoid,
          text: `${option.tipocomunicadoid} - ${option.tipocomunicadodescricao}`,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    getFieldState(errors) {
      if (!this.hasSubmitted) return null;
      return errors.length > 0 ? false : null;
    },
    onDateChange() {
      this.$nextTick(() => {
        if (this.$refs.refFormData) {
          this.$refs.refFormData.validate();
        }
      });
    },
  },
  watch: {
    value: {
      handler() {
        this.$nextTick(() => {
          this.formatarDatas();
          // Normaliza sempre que o value mudar
          this.dataForm.comunicadoativo = this.dataForm.comunicadoativo == 1 || this.dataForm.comunicadoativo === '1' ? 1 : 0;
        });
      },
      deep: true,
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok.prevent="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Código"
                label-for="comunicadoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Código"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadoid"
                    id="comunicadoid"
                    :state="getFieldState(errors)"
                    placeholder="Digite o código"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Titulo PTBR"
                label-for="comunicadotitulo_ptbr"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Titulo PTBR"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadotitulo_ptbr"
                    id="comunicadotitulo_ptbr"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Título PTBR"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Titulo Enus"
                label-for="comunicadotitulo_enus"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Titulo Enus"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadotitulo_enus"
                    id="comunicadotitulo_enus"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Título Enus"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Titulo Eses"
                label-for="comunicadotitulo_eses"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Titulo Eses"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadotitulo_eses"
                    id="comunicadotitulo_eses"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Título Eses"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Conteúdo PTBR"
                label-for="comunicadoconteudo_ptbr"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Conteúdo PTBR"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadoconteudo_ptbr"
                    id="comunicadoconteudo_ptbr"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Conteúdo PTBR"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Conteúdo Enus"
                label-for="comunicadoconteudo_enus"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Conteúdo Enus"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadoconteudo_enus"
                    id="comunicadoconteudo_enus"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Conteúdo Enus"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Conteúdo Eses"
                label-for="comunicadoconteudo_eses"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Conteúdo Eses"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadoconteudo_eses"
                    id="comunicadoconteudo_eses"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Conteúdo Eses"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Data Inicial"
                label-for="comunicadodatainicial"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Data Inicial"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadodatainicial"
                    id="comunicadodatainicial"
                    :state="getFieldState(errors)"
                    :disabled="dataForm.isDefault"
                    type="date"
                    @input="onDateChange"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Data Final"
                label-for="comunicadodatafinal"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Data Final"
                  :rules="`required|date_after_or_equal:${dataForm.comunicadodatainicial}`"
              >
                <b-form-input
                    v-model="dataForm.comunicadodatafinal"
                    id="comunicadodatafinal"
                    :state="getFieldState(errors)"
                    :disabled="dataForm.isDefault"
                    type="date"
                    @input="onDateChange"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Comunicado"
                label-for="tipocomunicadoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Tipo Comunicado"
                  rules="required"
              >
                <v-select v-model="dataForm.tipocomunicadoid" id="tipocomunicadoid" :options="dataFromApiTipoComunicado"
                  :disabled="dataForm.isDefault" label="text" :reduce="option => option.value" :clearable="false"
                  placeholder="Selecione" :state="getFieldState(errors)" />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Status"
                label-for="comunicadoativo"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Status"
                  rules="required"
              >
                <b-form-checkbox
                    v-model="dataForm.comunicadoativo"
                    id="comunicadoativo"
                    :state="getFieldState(errors)"
                    :disabled="dataForm.isDefault"
                    @change="() => { dataForm.comunicadoativo = dataForm.comunicadoativo ? 1 : 0 }"
                    :value="1"
                    :unchecked-value="0"
                >
                  Ativo
                </b-form-checkbox>
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="6"
              class="mb-1"
          >
            <b-form-group
                label="Tipo Texto"
                label-for="comunicadotipotexto"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Tipo Texto"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.comunicadotipotexto"
                    id="comunicadotipotexto"
                    :state="getFieldState(errors)"
                    placeholder="Digite o Tipo Texto"
                    :disabled="dataForm.isDefault"
                />
                <small v-if="hasSubmitted" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
